import { useEffect, useState } from "react";
import { Star } from "lucide-react";

const TESTIMONIALS = [
    {
        quote:
            "Nous avons fait appel à FOD, leur structure dédiée à l’optimisation des coûts bancaires, avec à la clé des économies tangibles. Nous avons d’ailleurs été étonnés avec mon associé sur le potentiel de gains sur ce poste de dépenses.",
        author: "Christophe Godeau & Jérôme Winterholer",
        role: "Dirigeants, KANDBAZ",
    },
    {
        quote:
            "Un accompagnement sérieux, à l'écoute et sans pression. Ils ont analysé mes frais et trouvé des solutions concrètes pour les réduire de façon significative. Des conseils clairs et transparents, une équipe disponible. Un vrai partenaire de confiance !",
        author: "Benoit Le Belzic",
        role: "INVESTANCE PARTNERS",
    },
    {
        quote:
            "J’aurais aimé avoir un banquier comme Hugo ! Mais c’est justement parce qu’il a choisi de passer “de l’autre côté” qu’il peut mettre son expérience et sa connaissance du fonctionnement bancaire au service de ses clients, avec davantage de recul et d’indépendance.",
        author: "Nina Blanchard",
        role: "Dirigeante, M’CONSTRUCTIONS",
    },
    {
        quote: "Merci pour votre aide et votre efficacité sur ce dossier.",
        author: "Olivier Pelletier",
        role: "CFO, Onoff",
    },
    {
        quote: "Merci pour votre aide précieuse et toutes les équipes impliquées !",
        author: "Dorian V.",
        role: "WITCO",
    },
];

export const TestimonialCarousel = () => {
    const [idx, setIdx] = useState(0);
    const [paused, setPaused] = useState(false);

    useEffect(() => {
        if (paused) return undefined;
        const t = setInterval(() => setIdx((i) => (i + 1) % TESTIMONIALS.length), 7000);
        return () => clearInterval(t);
    }, [paused]);

    const t = TESTIMONIALS[idx];
    return (
        <section
            aria-label="Avis clients"
            aria-roledescription="carrousel"
            data-testid="home-testimonials"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            className="flex-1 basis-[360px] min-w-0 bg-white text-navy rounded-2xl p-5 md:p-[34px] flex flex-col gap-3 md:gap-5"
        >
            <div className="flex justify-between items-center gap-3">
                <span className="text-[13px] md:text-xs font-semibold uppercase tracking-[0.14em] text-gold-text">
                    Ils nous ont fait confiance
                </span>
                <div aria-label="5 étoiles sur 5" role="img" className="flex gap-[3px] text-gold">
                    {[0, 1, 2, 3, 4].map((i) => (
                        <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
                    ))}
                </div>
            </div>
            <div aria-live="polite" className="md:min-h-[308px] flex flex-col justify-center">
                <figure key={idx} className="m-0 flex flex-col gap-3 md:gap-[18px] animate-fade-up" data-testid={`testimonial-${idx}`}>
                    <blockquote className={`m-0 text-base leading-normal font-medium ${t.quote.length > 200 ? "md:text-[19px]" : "md:text-[22px]"}`}>« {t.quote} »</blockquote>
                    <figcaption className="flex flex-col border-t border-border-soft pt-[18px]">
                        <strong className="text-[15px] font-semibold">{t.author}</strong>
                        <span className="text-[13px] text-grey-text-soft">{t.role}</span>
                    </figcaption>
                </figure>
            </div>
            <div role="group" aria-label="Choisir un avis" className="flex justify-center gap-1">
                {TESTIMONIALS.map((_, i) => (
                    <button
                        key={i}
                        type="button"
                        data-testid={`testimonial-dot-${i}`}
                        aria-label={`Afficher l’avis ${i + 1} sur ${TESTIMONIALS.length}`}
                        aria-current={i === idx}
                        onClick={() => setIdx(i)}
                        className="w-11 h-11 flex items-center justify-center"
                    >
                        <span
                            className={`h-1.5 rounded-[3px] transition-[width,background-color] duration-300 ${
                                i === idx ? "w-[26px] bg-navy" : "w-2.5 bg-border-strong"
                            }`}
                        />
                    </button>
                ))}
            </div>
        </section>
    );
};
